module.exports = __webpack_public_path__ + "static/media/Time_Table.a2c24db8.pdf";